import { Injectable } from "@angular/core";

 @Injectable({
  providedIn: "root",
})

export class Util {

 levantarEncuesta(idEncuesta: string, timeoutMs: number = 1000) {        
    setTimeout(() => {    
        this.dispatchEncuestaStorageEvent(idEncuesta);    
    }, timeoutMs);
  }

  dispatchEncuestaStorageEvent(idEncuesta: string) {
    localStorage.setItem('encuestaStorage', idEncuesta);
    const evento = new StorageEvent('storage', {
      key: 'encuestaStorage',
      oldValue: idEncuesta,
      newValue: idEncuesta,
      url: globalThis.location.href,
      storageArea: localStorage,
    });
    globalThis.dispatchEvent(evento);
    
  }
}